import React from "react"
import { Table, Badge, CustomInput } from "reactstrap"
import EventButton from "./AddEventButton"
import { useDispatch, useSelector } from "react-redux"
import { pinPlayers } from "../../../redux/actions/actions"

function PlayersTable({ reverse, columns, mvp, setMvp }) {
	const dispatch = useDispatch()
	// the columns[1].title thing is a quick fix of removing position if i dont need it
	const hasPosition = columns[1].title === "Pozicija"

	const team = useSelector((state) =>
		reverse ? state.players.awayTeam : state.players.homeTeam
	)

	const createCheckbox = ({ playerId, pin }) => {
		return (
			<td key={`checkbox-${playerId}`}>
				<CustomInput
					id={playerId}
					type="checkbox"
					onChange={() => dispatch(pinPlayers(playerId, reverse))}
					checked={pin}
				/>
			</td>
		)
	}

	const createRadioMVP = ({ playerId }) => {
		return (
			<td key={`mvp-${playerId}`}>
				<CustomInput
					id={playerId}
					type="radio"
					onChange={() => setMvp(playerId, team.teamId)}
					checked={playerId === mvp}
				/>
			</td>
		)
	}

	const createBadge = ({ playerId }) => {
		return (
			<td key={`badge-${playerId}`}>
				{playerId === team.captainId && (
					<Badge pill color="light-primary" className="mr-1">
						Kapetan
					</Badge>
				)}
			</td>
		)
	}

	const createRow = (player, index, teamName) => {
		const { tshirtNumber, position, name, surname } = player
		player.team = teamName
		const otherColumns = []

		for (let x = hasPosition ? 3 : 2; x < columns.length; x++) {
			switch (columns[x].key) {
				case "kapetan":
					otherColumns.push(createBadge(player))
					break
				case "actionBtn":
					otherColumns.push(
						<EventButton
							key={`btn-${player.playerId}`}
							player={player}
						/>
					)
					break
				case "pin":
					otherColumns.push(createCheckbox(player))
					break
				case "mvp":
					otherColumns.push(createRadioMVP(player))
					break
			}
		}

		return (
			<tr key={`playerRow-${teamName}-${index}`}>
				<td>{tshirtNumber}</td>
				{hasPosition && <td>{position}</td>}
				<td> {`${name} ${surname}`}</td>
				{otherColumns}
			</tr>
		)
	}

	return (
		<Table responsive style={reverse ? { direction: "rtl" } : {}}>
			<thead>
				<tr>
					{columns.map((column, index) => (
						<th key={`th-${index}`}>{column.title}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{team?.players?.map((player, index) =>
					createRow(player, index, team.name)
				)}
			</tbody>
		</Table>
	)
}

export default PlayersTable
